export const TAB_OPTIONS_LABELS = {
  PARAMETERS: 'Settings',
  RESULTS: 'Results',
};

export const CHANGE_TYPE = {
  NONE: 0,
  '3D': 1,
  '2D': 2,
  DATA: 4,
};
